import { useEffect, useState } from "react";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import { tplApi, setToken } from "@/lib/templateApi";

export default function AdminVerify() {
  const { slug } = useParams();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState("");

  useEffect(() => {
    const token = params.get("token");
    if (!token) {
      setError("No token provided");
      return;
    }
    tplApi
      .verifyToken(token)
      .then((res) => {
        setToken(res.token);
        navigate(`/t/${slug}/admin`, { replace: true });
      })
      .catch((e) => setError(e.message));
  }, [params, slug, navigate]);

  if (error) {
    return (
      <div className="min-h-screen bg-[#0F172A] flex items-center justify-center" data-testid="verify-error">
        <div className="text-center">
          <h1 className="text-xl text-white font-bold mb-2">Link expired or invalid</h1>
          <p className="text-slate-400 text-sm mb-4">{error}</p>
          <a href={`/t/${slug}/admin/login`} className="text-orange-500 hover:underline text-sm">
            Request a new link
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#0F172A] flex items-center justify-center">
      <div className="flex items-center gap-3 text-slate-400">
        <div className="w-5 h-5 border-2 border-slate-600 border-t-white rounded-full animate-spin" />
        Signing you in...
      </div>
    </div>
  );
}
